import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_divider = _resolveComponent("el-divider");
    const _component_richtext_form = _resolveComponent("richtext-form");
    const _component_label_form = _resolveComponent("label-form");
    return (_ctx.preview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_divider),
            _createElementVNode("span", { innerHTML: _ctx.description }, null, 8 /* PROPS */, _hoisted_2),
            _createVNode(_component_el_divider)
        ]))
        : (_openBlock(), _createBlock(_component_label_form, { key: 1 }, {
            default: _withCtx(() => [
                _createVNode(_component_richtext_form, {
                    modelValue: _ctx.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.value) = $event))
                }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }));
}
